export const ENVIRONMENT_COMMON = {
  application: 'sellions_crh',
  authClientId: 'sellions-ionic',
  TrackJS: {
    token: '87322847c1c44288a533c83b31fe1064',
    enabled: true,
    application: 'crh',
    console: { display: true },
  },
  versionWeb: 'crh_0.0.1',
  versionIOS: 'crh_0.1.0',
  versionAndroid: 'crh_0.0.1',
  defaultDataViewTimeout: 1000
}



// WEBPACK FOOTER //
// ./environments/environment.common.ts